import { createContext } from "react";
import { IActiveModuleContext } from "./ActiveModuleTypes";

const ActiveModuleContext = createContext<IActiveModuleContext | null>(null);

ActiveModuleContext.displayName = "ActiveModuleContext";

export default ActiveModuleContext;
